import { type AccessControlConfig } from 'legacy/components/AccessControl/accessControl.utils'
import { Flipper } from 'legacy/contexts/flipper/FlipperContext'

const StoreOperationsRouteFlipperAccessControl: AccessControlConfig = {
  flippers: Flipper.StoreOperationNavigation,
}

const StoreOperationsRouteWarehouseFlipperAccessControl: AccessControlConfig = {
  warehouseFlippers: Flipper.StoreOperationNavigation,
}

export const StoreOperationsRouteAccessControl: AccessControlConfig[] = [
  /**
   * As long as the user has access to one of them, the menu entry and page
   * should be visible.
   *
   * The reason why these flippers are declared this way is because the
   * `AccessControlConfig` instances use && logic across their flipper
   * declarations. In this case we want to use || logic. Which is what this
   * `AccessControlConfig[]` does for us.
   *
   * Either the user has access via PartnerUser:ID flipper or
   * via Warehouse:ID flipper.
   */
  StoreOperationsRouteWarehouseFlipperAccessControl,
  StoreOperationsRouteFlipperAccessControl,
]
